// Name: ConnectionStateStore.js
// Author: Claude Code
// Date: 03/16/2026
// Description: Store to track WebSocket connection state. Manages connection status
// and notifies subscribers when connection is established.

const ConnectionState = {
    CONNECTING: 'CONNECTING',
    CONNECTED: 'CONNECTED'
};

class ConnectionStateStore {
    constructor() {
        this.state = ConnectionState.CONNECTING;
        this.subscribers = [];
    }

    subscribe(listener) {
        this.subscribers.push(listener);
    }

    getState() {
        return this.state;
    }

    isConnected() {
        return this.state === ConnectionState.CONNECTED;
    }

    setState(newState) {
        if (this.state !== newState) {
            this.state = newState;
            console.log('ConnectionStateStore: ' + newState);

            // Notify all subscribers of the state change
            this.subscribers.forEach(listener => {
                listener(newState);
            });
        }
    }

    setConnected() {
        this.setState(ConnectionState.CONNECTED);
    }

    setConnecting() {
        this.setState(ConnectionState.CONNECTING);
    }
}

export default new ConnectionStateStore();
export { ConnectionState };
